module.exports = __webpack_public_path__ + "static/media/next.56b7235d.svg";